import React from "react";
import BillPaymentImg from "../../img/bill_payment_icon.png";

export const BillPaymentIcon = (props) => {
  return (
    <>
      <img className="df-w-46" src={props?.icon || BillPaymentImg} />
    </>
  );
};
